import type { CCPOfferingContent } from '@/contentful/product-catalog.tsx';

import { getContentfulProductCatalogClient } from '../../pricing-calculator/src/client/contentful-clients.ts';

export interface GetPricingTiersTableDataArgs {
	sku: string;
}

export async function getPricingTiersTableData(
	args: GetPricingTiersTableDataArgs,
): Promise<CCPOfferingContent | undefined> {
	const { sku } = args;
	const client = getContentfulProductCatalogClient();
	const offerings = await client.getCCPPricingData([sku]);
	return offerings[sku];
}
